import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { RecipientTag } from '../../../utils';

const FormTriggers = ({
  existingRecipients,
}: {
  existingRecipients: RecipientTag[];
}) => {
  // Get Formik's helpers
  const { validateForm } = useFormikContext();

  // This effect runs every time the existingRecipients array reference changes.
  useEffect(() => {
    // Calling validateForm forces Formik to run all validation rules again,
    // which will now use the new (potentially smaller) existingRecipients array length.
    validateForm();
  }, [existingRecipients, validateForm]); // include validateForm in dependencies for completeness

  return null; // This component doesn't render anything
};

export default FormTriggers;
